import type IAnticipation from 'interfaces/IAnticipation';

class Anticipation implements IAnticipation {
  invoice_id: string = this.anticipation.invoice_id || '';
  value: number = this.anticipation.value || 0;
  initial_fee: number = this.anticipation.initial_fee || 0;
  daily_fee: number = this.anticipation.daily_fee || 0;
  fee: number = this.anticipation.fee || 0;
  net_gain: number = Number(this.anticipation.net_gain.toFixed(2)) || 0;
  payment_method: string = this.anticipation.payment_method || '';
  description: string = this.anticipation.description || '';
  selectable: boolean = this.anticipation.selectable || false;

  constructor(private anticipation: Partial<IAnticipation> = {}) {}

  serviceFormat() {
    return this.anticipation;
  }
}

export default Anticipation;
